import OffersCds from "./OffersCds.vue"

const offersCtrl = new Vue({
    el: '#mobile-offers-cds',
    components: {OffersCds},
});
